import axios from './axios';

export default class QuestionProgress {
  static submit(_, questionProgress, choices, answer) {
    return axios
      .put(`/assessments/question_progresses/${questionProgress.id}/submit`, { choices, answer })
      .then(response => response.data);
  }
}
